import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useProtectedRoute } from "../hooks/useProtectedRoute";

const Protected = () => {
  const location = useLocation();
  const { shouldRenderOutlet, shouldRedirect } = useProtectedRoute(
    location.pathname
  );

  if (shouldRenderOutlet) {
    return <Outlet />;
  }

  return shouldRedirect ? <Navigate to="/my-task?tab=mine" /> : <Outlet />;
};

export default Protected;
